import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserService } from 'src/app/_services/user.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TabItems } from "../../dashboard/_services/tab.service";
import { BusesTabItems } from "../../dashboard/_services/tab.service";
import { SchoolManagementTabItems } from "../../dashboard/_services/tab.service";
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { Subject, takeUntil } from 'rxjs';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  animations: [
    trigger('rotateAnimation', [
      state('0', style({ transform: 'rotate(0)' })),
      state('180', style({ transform: 'rotate(180deg)' })),
      transition('0 <=> 180', animate('300ms ease-in-out')),
    ]),
  ],
})
export class SideBarComponent implements OnInit {
  activeModule: string;
  userPlan;
  currLang;
  tabs = [];
  BusesTabItems = [];
  SchoolManagementTabItems = [];
  activeTab: string;
  schoolImg: string;
  schoolName: string;
  userName: string;
  moduleName: string;
  userId;
  currentUserKeys = ['name', 'image_path', 'gender', 'national_id', 'country_code', 'phone', 'email'];
  isCallingScreenBeta;
  showToggleIcon = false;
  isExpanded;
  destroy$ = new Subject<void>(); 

  @Output() expandState = new EventEmitter<any>();

  constructor(private router: Router, private userService: UserService, private dataService: DataService, private globalService: GlobalService, private translate: TranslateService,private amplitudesService: AmplitudeService
    ) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit() {
    // this.dataService.getIsBeta().pipe(takeUntil(this.destroy$)).subscribe(res=>{
    //   this.isBeta = res;
    // })
    this.activeModule = window.location.pathname.split('/')[1];
    this.userPlan = this.userService.userPlan;
    if (this.userPlan === null) {
      this.dataService.getSchoolInfo().pipe(takeUntil(this.destroy$)).subscribe(res => {
        this.userService.userPlan = res[0]?.subscription_plan?.is_free == 0 ? 'paid' : 'free';
        this.userPlan = this.userService?.userPlan;
      })
    }
    // this.schoolName = localStorage.getItem('schoolName');
    // this.schoolImg = environment.img_url + localStorage.getItem('schoolImage');
    this.userName = 'name';
    // this.userId = localStorage.getItem('userId')
    // this.userService.getProfile(this.userId).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
    //   for (const key of this.currentUserKeys) {
    //     this.dataService.currentUser[key] = res[key];
    //   }
    //   this.dataService.currentUser['role_type'] = res.roles.find(role => role.name == localStorage.getItem('loginAs')).name;
    // })
    
    // Subscribe to calling screen beta status
    this.dataService.isCallingScreenBeta.pipe(takeUntil(this.destroy$)).subscribe(isBeta => {
      this.isCallingScreenBeta = isBeta;
    });
    
    this.isExpanded = localStorage.getItem('sideBarWidth') == '70px' ? false : true;
  }

  getRoute(moduleName) {

    if (moduleName === this.router.url.split('/')[1]) {
      // return `/${moduleName}/${this.router.url.split('/')[2]}`
    }
    else {
      return `/${moduleName}/${this.getDefautlRoutesForModuels(moduleName)}`
    }
  }

    getDefautlRoutesForModuels(sectionName) {
    let result;
    switch (sectionName) {
      case 'dashboard':
        result = 'students';
        break;
      case 'messages':
        result = 'messages-list';
        break;
      case 'messages-new':
        result = 'view-messages';
        break;
      case 'buses':
        result = 'students';
        break;
      case 'reports':
        result = 'dashboard';
        break;
        case 'reports-new':
          result = 'dashboard';
          break;
      case 'calling-screen':
        result = this.getCallingScreenRoute();
        break;
      case 'school-management':
        result = 'school-info';
        break;
        case 'names-sounds':
        result = '';
        break;
      case 'grade-management':
        result = 'grades';
        break;
        case 'delegation':
        result = 'listing';
        break;
        case 'attendance':
          result = 'attendance-dashboard';
          break;
      case 'data-management':
        result = 'students';
        break;
      case 'appointments':
        result = 'requests';
        break;
      default:
        break;
    }
    return result;
  }

  getCallingScreenRoute(): string {
    // Check if this school is beta for calling screen
    if (this.isCallingScreenBeta) {
      return 'calling-screen-beta';
    }
    return 'calling-screen';
  }


  // temp
  toggleLang() {
    if (this.currLang == 'en') {
      this.globalService.setLang('ar');
      this.translate.use('ar');
      this.currLang = 'ar';
    } else {
      this.globalService.setLang('en');
      this.currLang = 'en';
      this.translate.use('en');
    }
    this.router.navigateByUrl(this.router.url)
  }
  logOut() {
    this.userService.logOut();
  }
  openProfile() {
    this.globalService.stopLoading();
    $("#profileModal").modal("show");
  }

  sendExpandState(): void {
    this.isExpanded = !this.isExpanded;
    this.expandState.emit(this.isExpanded);
  }

  amplitudeEventHandler(tab){
    switch (tab) {
      case 'dashboard':
        this.amplitudesService.trackEvent('CTA.Sidenav.Dashboard',{})
        break;
        case 'school-management':
        this.amplitudesService.trackEvent('CTA.SideNav.SchoolManagement',{})
        break;
      default:
        break;
    }
  }

  ngOnDestroy(): void {
  }
}
